export const lime = {
  100: 'var(--bfc-v2-color-lime-100, #e9fec8)',
  200: 'var(--bfc-v2-color-lime-200, #d6f589)',
  300: 'var(--bfc-v2-color-lime-300, #b3ee2b)',
  400: 'var(--bfc-v2-color-lime-400, #a3e635)',
  500: 'var(--bfc-v2-color-lime-500, #91cf02)',
  600: 'var(--bfc-v2-color-lime-600, #83b300)',
  700: 'var(--bfc-v2-color-lime-700, #647f01)',
  800: 'var(--bfc-v2-color-lime-800, #546c00)',
  900: 'var(--bfc-v2-color-lime-900, #3f5304)',
  1000: 'var(--bfc-v2-color-lime-1000, #2b331b)',
  DEFAULT: 'var(--bfc-v2-color-lime-700, #647f01)', // 700
};
